import './ErrorCard.scss';

import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { selectLocalSettings } from '../../ducks/settings';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

interface OwnProps {
  text: React.ReactNode;
  helpText?: React.ReactNode;
  error?: Error;
  showHome?: boolean;
  showReload?: boolean;
}

type Props = OwnProps;

function ErrorCard({ text, helpText }: Props) {
  const lang = useSelector(selectLocalSettings);

  const onClickReload = useCallback(() => window.location.reload(), []);
  const onClickHome = useCallback(
    () => (window.location.href = `/${lang}/`),
    []
  );

  const intl = useIntl();

  return (
    <div className="fixFooter errorCard">
      <h3>{intl.formatMessage({ ...siteMessages.ERROR_TITLE })}</h3>
      <p>{text}</p>
      <div className="button-wrapper">
        <Button className="m-2" onClick={onClickReload}>
          {intl.formatMessage({ ...siteMessages.ERROR_RELOAD })}
        </Button>
        <Button className="m-2" variant="secondary" onClick={onClickHome}>
          {intl.formatMessage({ ...siteMessages.ERROR_HOME })}
        </Button>
      </div>
      <p className="mt-4">
        {helpText || (
          <span
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({ ...siteMessages.ERROR_CONTACT })
            }}
          />
        )}
      </p>
    </div>
  );
}

ErrorCard.defaultProps = {
  showHome: true,
  showReload: true,
  error: undefined,
  helpText: undefined
};

export default ErrorCard;
